import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

function Perfil() {
    const navigate = useNavigate();
    const usuario = JSON.parse(localStorage.getItem('usuario') || 'null');

    const [perfil, setPerfil] = useState(null);
    const [equipos, setEquipos] = useState([]);
    const [empresa, setEmpresa] = useState(null);

    const [nombre, setNombre] = useState('');
    const [passForm, setPassForm] = useState({ actual: '', nueva: '', confirmar: '' });

    const [msgPerfil, setMsgPerfil] = useState('');
    const [errPerfil, setErrPerfil] = useState('');
    const [msgPass, setMsgPass] = useState('');
    const [errPass, setErrPass] = useState('');
    const [cargando, setCargando] = useState(false);

    const traer = useCallback(async () => {
        try {
            const [resPerfil, resEquipos] = await Promise.all([
                axios.get(`${API}/api/perfil`, { headers: headers() }),
                axios.get(`${API}/api/mis-equipos`, { headers: headers() }),
            ]);
            setPerfil(resPerfil.data.usuario);
            setNombre(resPerfil.data.usuario.nombre);
            setEmpresa(resPerfil.data.empresa);
            setEquipos(resEquipos.data);
        } catch (e) { console.error(e); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const guardarNombre = async (e) => {
        e.preventDefault(); setMsgPerfil(''); setErrPerfil(''); setCargando(true);
        try {
            await axios.post(`${API}/api/perfil/nombre`, { nombre }, { headers: headers() });
            // Actualizar localStorage
            const u = JSON.parse(localStorage.getItem('usuario') || '{}');
            localStorage.setItem('usuario', JSON.stringify({ ...u, nombre }));
            setMsgPerfil('Nombre actualizado correctamente');
            traer();
        } catch (err) { setErrPerfil(err.response?.data?.error || 'Error al actualizar'); }
        finally { setCargando(false); }
    };

    const cambiarPassword = async (e) => {
        e.preventDefault(); setMsgPass(''); setErrPass('');
        if (passForm.nueva !== passForm.confirmar) { setErrPass('Las contraseñas no coinciden'); return; }
        if (passForm.nueva.length < 6) { setErrPass('La contraseña debe tener al menos 6 caracteres'); return; }
        setCargando(true);
        try {
            await axios.post(`${API}/api/perfil/password`, {
                passwordActual: passForm.actual,
                passwordNuevo: passForm.nueva,
            }, { headers: headers() });
            setMsgPass('Contraseña actualizada correctamente');
            setPassForm({ actual: '', nueva: '', confirmar: '' });
        } catch (err) { setErrPass(err.response?.data?.error || 'Error al cambiar contraseña'); }
        finally { setCargando(false); }
    };

    return (
        <div style={s.page}>
            <Navbar />
            <div style={s.contenido}>
                <div style={s.header}>
                    <div>
                        <p style={s.headerSub}>MI CUENTA</p>
                        <h2 style={s.headerTitulo}>Perfil</h2>
                    </div>
                    <button style={s.btnVolver} onClick={() => navigate('/dashboard')}>← Dashboard</button>
                </div>

                <div style={s.grid}>

                    {/* Columna izquierda */}
                    <div style={s.columna}>

                        {/* Info de la cuenta */}
                        <div style={s.card}>
                            <p style={s.cardTitulo}>Información de la cuenta</p>
                            <div style={s.infoRow}>
                                <span style={s.infoLabel}>Email</span>
                                <span style={s.infoValor}>{perfil?.email || '—'}</span>
                            </div>
                            <div style={s.infoRow}>
                                <span style={s.infoLabel}>Rol</span>
                                <span style={{...s.pill, ...(perfil?.rol === 'superadmin' ? s.pillAmbar : perfil?.rol === 'admin_empresa' ? s.pillCyan : s.pillGris)}}>
                                    {perfil?.rol || '—'}
                                </span>
                            </div>
                            <div style={s.infoRow}>
                                <span style={s.infoLabel}>Cuenta creada</span>
                                <span style={s.infoValor}>{perfil?.fecha_creacion ? new Date(perfil.fecha_creacion).toLocaleDateString() : '—'}</span>
                            </div>
                        </div>

                        {/* Info empresa */}
                        {empresa && (
                            <div style={s.card}>
                                <p style={s.cardTitulo}>Mi empresa</p>
                                <div style={s.infoRow}>
                                    <span style={s.infoLabel}>Nombre</span>
                                    <span style={s.infoValor}>{empresa.nombre}</span>
                                </div>
                                <div style={s.infoRow}>
                                    <span style={s.infoLabel}>Email empresa</span>
                                    <span style={{...s.infoValor, fontFamily:'IBM Plex Mono, monospace', fontSize:'0.82rem'}}>{empresa.email}</span>
                                </div>
                                {empresa.telefono && (
                                    <div style={s.infoRow}>
                                        <span style={s.infoLabel}>Teléfono</span>
                                        <span style={s.infoValor}>{empresa.telefono}</span>
                                    </div>
                                )}
                                {empresa.zona_horaria && (
                                    <div style={s.infoRow}>
                                        <span style={s.infoLabel}>Zona horaria</span>
                                        <span style={{...s.infoValor, fontSize:'0.8rem'}}>{empresa.zona_horaria}</span>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Equipos asignados */}
                        <div style={s.card}>
                            <p style={s.cardTitulo}>Equipos de mi empresa</p>
                            {equipos.length === 0 ? (
                                <p style={{color:'var(--text-dim)', fontSize:'0.85rem'}}>No hay equipos asignados.</p>
                            ) : (
                                equipos.map(eq => (
                                    <div key={eq.id} style={s.equipoRow}>
                                        <div>
                                            <p style={{margin:0, fontWeight:'500', color:'var(--text-primary)', fontSize:'0.88rem'}}>{eq.descripcion || eq.serie}</p>
                                            <p style={{margin:0, fontFamily:'IBM Plex Mono, monospace', fontSize:'0.75rem', color:'var(--text-muted)', marginTop:'2px'}}>{eq.serie}</p>
                                        </div>
                                        <div style={{textAlign:'right'}}>
                                            {eq.num_interno && <p style={{margin:0, fontFamily:'IBM Plex Mono, monospace', fontSize:'0.75rem', color:'var(--accent-cyan)'}}>: {eq.num_interno}</p>}
                                            <span style={{...s.pill,...(eq.estado==='activo'?s.pillVerde:s.pillRojo), fontSize:'0.68rem'}}>{eq.estado}</span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Columna derecha */}
                    <div style={s.columna}>

                        {/* Editar nombre */}
                        <div style={s.card}>
                            <p style={s.cardTitulo}>Editar nombre</p>
                            <form onSubmit={guardarNombre} style={s.form}>
                                <div style={s.campo}>
                                    <label style={s.label}>Nombre</label>
                                    <input style={s.input} value={nombre}
                                        onChange={e => setNombre(e.target.value)}
                                        placeholder="Tu nombre completo" required />
                                </div>
                                {msgPerfil && <div style={s.successBox}>✓ {msgPerfil}</div>}
                                {errPerfil && <div style={s.errorBox}>⚠ {errPerfil}</div>}
                                <button type="submit" style={s.btnPrimario} disabled={cargando}>
                                    {cargando ? 'Guardando...' : 'Guardar nombre'}
                                </button>
                            </form>
                        </div>

                        {/* Cambiar contraseña */}
                        <div style={s.card}>
                            <p style={s.cardTitulo}>Cambiar contraseña</p>
                            <form onSubmit={cambiarPassword} style={s.form}>
                                <div style={s.campo}>
                                    <label style={s.label}>Contraseña actual</label>
                                    <input type="password" style={s.input} value={passForm.actual}
                                        onChange={e => setPassForm({...passForm, actual: e.target.value})}
                                        placeholder="••••••••" required />
                                </div>
                                <div style={s.campo}>
                                    <label style={s.label}>Nueva contraseña</label>
                                    <input type="password" style={s.input} value={passForm.nueva}
                                        onChange={e => setPassForm({...passForm, nueva: e.target.value})}
                                        placeholder="Mínimo 6 caracteres" required />
                                </div>
                                <div style={s.campo}>
                                    <label style={s.label}>Confirmar nueva contraseña</label>
                                    <input type="password" style={s.input} value={passForm.confirmar}
                                        onChange={e => setPassForm({...passForm, confirmar: e.target.value})}
                                        placeholder="Repetí la contraseña" required />
                                </div>
                                {msgPass && <div style={s.successBox}>✓ {msgPass}</div>}
                                {errPass && <div style={s.errorBox}>⚠ {errPass}</div>}
                                <button type="submit" style={s.btnPrimario} disabled={cargando}>
                                    {cargando ? 'Guardando...' : 'Cambiar contraseña'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const s = {
    page: { minHeight:'100vh', backgroundColor:'var(--bg-base)' },
    contenido: { padding:'32px 36px', maxWidth:'1100px', margin:'0 auto' },
    header: { display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:'28px' },
    headerSub: { fontSize:'0.7rem', color:'var(--accent)', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:'6px' },
    headerTitulo: { fontSize:'1.5rem', fontWeight:'600', color:'var(--text-primary)', letterSpacing:'-0.02em' },
    btnVolver: { background:'none', border:'1px solid var(--border-light)', color:'var(--text-muted)', padding:'7px 16px', borderRadius:'7px', cursor:'pointer', fontFamily:'IBM Plex Sans,sans-serif', fontSize:'0.85rem' },
    grid: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' },
    columna: { display:'flex', flexDirection:'column', gap:'20px' },
    card: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'22px 24px' },
    cardTitulo: { fontSize:'0.95rem', fontWeight:'600', color:'var(--text-primary)', marginBottom:'16px' },
    infoRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:'1px solid var(--border)' },
    infoLabel: { fontSize:'0.78rem', color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.05em' },
    infoValor: { fontSize:'0.88rem', color:'var(--text-primary)', fontWeight:'500' },
    equipoRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom:'1px solid var(--border)' },
    form: { display:'flex', flexDirection:'column', gap:'14px' },
    campo: { display:'flex', flexDirection:'column', gap:'6px' },
    label: { fontSize:'0.68rem', color:'var(--text-muted)', letterSpacing:'0.06em', textTransform:'uppercase' },
    input: { padding:'9px 12px', backgroundColor:'var(--bg-base)', border:'1px solid var(--border-light)', borderRadius:'7px', color:'var(--text-primary)', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', outline:'none' },
    btnPrimario: { padding:'9px 20px', backgroundColor:'var(--accent)', color:'white', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500', alignSelf:'flex-start' },
    successBox: { backgroundColor:'rgba(16,196,138,0.08)', border:'1px solid rgba(16,196,138,0.2)', color:'var(--success)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    errorBox: { backgroundColor:'rgba(240,77,94,0.08)', border:'1px solid rgba(240,77,94,0.2)', color:'var(--danger)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    pill: { padding:'2px 9px', borderRadius:'20px', fontSize:'0.72rem', fontWeight:'500', border:'1px solid' },
    pillVerde: { backgroundColor:'rgba(16,196,138,0.1)', color:'var(--success)', borderColor:'rgba(16,196,138,0.25)' },
    pillRojo: { backgroundColor:'rgba(240,77,94,0.1)', color:'var(--danger)', borderColor:'rgba(240,77,94,0.25)' },
    pillCyan: { backgroundColor:'rgba(0,194,212,0.1)', color:'var(--accent-cyan)', borderColor:'rgba(0,194,212,0.2)' },
    pillAmbar: { backgroundColor:'rgba(245,166,35,0.1)', color:'var(--warning)', borderColor:'rgba(245,166,35,0.25)' },
    pillGris: { backgroundColor:'rgba(90,116,153,0.15)', color:'var(--text-muted)', borderColor:'var(--border)' },
};

export default Perfil;